import {
  getFourSideStringFormat,
  getProductButtonStyleAndTextColorValue,
} from './style';

export const getMerchantSpecificThemeFlags = ({
  shopURL,
  theme,
  offerType = '',
}) => {
  const isEmbedded = !offerType.includes('popup');

  const {
    styleValue: productButtonStyle,
    textColorValue: productButtonTextColor,
  } = getProductButtonStyleAndTextColorValue({
    theme,
    isEmbedded,
    isBundleOffer: offerType.includes('bundle'),
  });

  const newValues = {
    isSelectedVariantItemsDisabled: false,
    offerHeaderMobileFont: 'inherit',
    // prev productNameFont search with productNameFont for merchant specific items
    isPopupCloseButtonEnabled: true,
    isPopupBackdropClickEnabled: false,
    isToggleCheckboxOnImageClick: false,
    // productVariantTextAlignment: 'center',
    // productVariantMobileTextAlignment: 'center',
    // productVariantPadding: '12px 16px 12px 16px',
    // productVariantMobilePadding: '12px 16px 12px 16px',
    // productVariantMargin: '0px 0px 8px 0px',
    // productVariantMobileMargin: '0px 0px 8px 0px',
    // productVariantWidth: '180',
    // productVariantMobileWidth: '180',
    // offerHeaderPadding: '0px 0px 0px 0px', // (Compact & LargeImage & LineVertical(withCarousel) - '0px 10px 0px 10px'), (Line, Checkbox & LineVertical(withoutCarousel) - '0px 0px 0px 0px'),
    // offerHeaderMobilePadding: '0px 0px 0px 0px', // (Compact & LargeImage & LineVertical(withCarousel) - '0px 10px 0px 10px'), (Line, Checkbox & LineVertical(withoutCarousel) - '0px 0px 0px 0px'),
    // offerHeaderMargin: '0px 0px 24px 0px',
    // productNameTextAlignment: 'left',
    // productNameMobileTextAlignment: 'left',
    // productNameMargin: '0px 0px 0px 0px',
    // productNameMobileMargin: '0px 0px 0px 0px',
    // productPriceTextAlignment: 'left',
    // productPriceMobileTextAlignment: 'left',
    // productPriceMargin: '8px 0px 8px 0px',
    // productButtonPadding: '12px 16px 12px 16px',
    // productButtonWidth: '0',
    // productButtonMobileWidth: '0',
    // productRemoveButtonWidth: '0',
    // productRemoveButtonMobileWidth: '0',
    productsContainerPadding: '0px 0px 0px 0px',
    productsContainerMargin: '0px 0px 0px 0px',
    // productItemPadding: '0px 0px 0px 0px', // (Compact & LargeImage & LineVertical(withCarousel) - '10px 10px 10px 10px'), (Line, Checkbox & LineVertical(withoutCarousel) - '0px 0px 0px 0px'),
    // productItemMobilePadding: '0px 0px 0px 0px', // (Compact & LargeImage & LineVertical(withCarousel) - '10px 10px 10px 10px'), (Line, Checkbox & LineVertical(withoutCarousel) - '0px 0px 0px 0px'),
    // productItemMargin: '0px 0px 10px 0px', // (Compact & LargeImage & LineVertical(withCarousel) - '0px 0px 0px 0px'), (Line, Checkbox & LineVertical(withoutCarousel) - '0px 0px 10px 0px'),
    // productItemMobileMargin: '0px 0px 10px 0px', // (Compact & LargeImage & LineVertical(withCarousel) - '0px 0px 0px 0px'), (Line, Checkbox & LineVertical(withoutCarousel) - '0px 0px 10px 0px'),
    // widgetPadding: '0px 0px 0px 0px', // (Compact & LargeImage & LineVertical(withCarousel) - '10px 0px 0px 0px'), (Line, Checkbox & LineVertical(withoutCarousel) - '10px 10px 0px 10px'),
    // widgetMargin: '0px 0px 0px 0px',
    // widgetMobilePadding: '0px 0px 0px 0px', // (Compact & LargeImage & LineVertical(withCarousel) - '10px 0px 0px 0px'), (Line, Checkbox & LineVertical(withoutCarousel) - '10px 10px 0px 10px'),
    // widgetMobileMargin: '0px 40px 0px 40px',
    widgetBorderRadius: '0px 0px 0px 0px',
    // productDescriptionTextAlignment: 'left', // added to reducer
    // offerSubtitleTextAlignment: 'center',
    // offerSubtitleMobileTextAlignment: 'center',

    // fbt
    fbtImagesContainerPadding: '0px 0px 0px 0px',
    fbtImagesContainerMargin: '0px 0px 0px 0px',
    fbtLargeWidthConAlignment: 'left',
    fbtLargeWidthImagesAlignment: 'left',
    // vd
    vdQuantityOptionContainerPadding: '0px 0px 0px 0px',
    vdQuantityOptionContainerMargin: '0px 0px 10px 0px',
    vdVariantSecBorderRadius: getFourSideStringFormat(
      theme.vdVariantSecBorderRadius,
    ),
    // vdAddMoreVariantButtonMobileWidth: '0',
    // vdQuantitySelectorWidth: '0',
    // vdQuantitySelectorMobileWidth: '0',
    // CVB
    // get cvbOfferHeaderSuccessFontFamily() {
    //   return this.offerHeaderFontFamily;
    // },
    cvbMilestoneValueTextAlignment: 'center',
    cvbMilestoneTextAlignment: 'center',
    cvbBarBorderRadius: getFourSideStringFormat(theme.cvbBarBorderRadius),

    // Popup
    // offerHeaderContainerPadding: '20px 35px 20px 35px',
    // offerHeaderContainerMargin: '0px 0px 0px 0px',
    // bottomBarContainerPadding: '16px 16px 16px 16px',
    // bottomBarContainerMargin: '0px 0px 0px 0px',
    // bottomBarContainerMobilePadding: '16px 16px 16px 16px',
    // bottomBarContainerMobileMargin: '0px 0px 0px 0px',
    // bottomBarButtonFontFamily: 'inherit',
    // bottomBarButtonTextAlignment: 'center',
    // bottomBarButtonPadding: '4px 5px 4px 5px',
    // bottomBarButtonMargin: '0px 0px 0px 0px',
    // bottomBarButtonWidth: '0',
    // bottomBarButtonMobileWidth: '0',
    // bottomBarSecondaryButtonFontFamily: 'inherit',
    // bottomBarSecondaryButtonTextAlignment: 'center',
    // bottomBarSecondaryButtonPadding: '4px 5px 4px 5px',
    // bottomBarSecondaryButtonMargin: '0px 0px 0px 0px',
    // bottomBarSecondaryButtonWidth: '0',
    // bottomBarSecondaryButtonMobileWidth: '0',

    // bundle
    // bundleTaglineTextAlignment: 'center',
    // bundleTaglineFontFamily: 'inherit',
    // bundleTaglinePadding: '4px 5px 4px 5px',
    // bundleTaglineMargin: '0px 0px 10px 0px',
    bundlePriceBarBorderRadius: getFourSideStringFormat(
      theme.bundlePriceBarBorderRadius,
    ),
    // triggerProductOverlayTextAlignment: 'center',
    // triggerProductOverlayFontFamily: 'inherit',
    // triggerProductOverlayPadding: '5px 5px 5px 5px',
    // triggerProductOverlayMargin: '0px 0px 0px 0px',

    // discount code
    discountCodeWidgetPadding: '8px 0px 8px 0px',
    discountCodeWidgetMargin: '0px 0px 0px 0px',

    discountCodeButtonStyle: 'filled',
    discountCodeButtonBorderRadius: '3',
    discountCodeButtonFontFamily: 'inherit',
    discountCodeButtonTextAlignment: 'center',
    discountCodeButtonPadding: '10px 12px 10px 12px',
    discountCodeButtonMargin: '0px 0px 0px 0px',
    discountCodeButtonWidth: '0',
    discountCodeButtonHeight: '40',
    discountCodeInputBorderRadius: '3',
    discountCodeInputPadding: '10px 12px 10px 12px',
    discountCodeInputMargin: '0px 8px 0px 0px',

    discountCodeChipBackgroundColor: '#d3d3d3',
    discountCodeChipBorderRadius: '3px 3px 3px 3px',
    discountCodeChipFontSize: '14',
    discountCodeChipTextColor: '#000000',
    discountCodeChipPadding: '5px 7px 5px 5px',
    discountCodeChipMargin: '8px 0px 0px 0px',

    discountCodeEnabledTextAlignment: 'center',
    discountCodeEnabledFontFamily: 'inherit',
    discountCodeEnabledPadding: '4px 5px 4px 5px',
    discountCodeEnabledMargin: '0px 0px 0px 0px',

    discountCodeAppliedInfoTextAlignment: 'left',
    discountCodeAppliedInfoFontFamily: 'inherit',
    discountCodeAppliedInfoPadding: '0px 0px 0px 0px',
    discountCodeAppliedInfoMargin: '6px 0px 0px 0px',

    discountCodeInvalidTextAlignment: 'left',
    discountCodeInvalidFontFamily: 'inherit',
    discountCodeInvalidPadding: '0px 0px 0px 0px',
    discountCodeInvalidMargin: '6px 0px 0px 0px',

    discountCodePopupTitleTextAlignment: 'left',
    discountCodePopupTitleFontFamily: 'inherit',
    discountCodePopupTitlePadding: '0px 0px 0px 0px',
    discountCodePopupTitleMargin: '0px 0px 0px 0px',

    // floating button styles
    floatingRightPosition: '10px',
    floatingBottomPosition: '14%',
    // floatingBorderRadius: '100',
    // floatingTextAlignment: 'center',
    // floatingFontFamily: 'inherit',
    // floatingPadding: '4px 4px 4px 4px',
    // floatingMargin: '0px 0px 0px 0px',
    // floatingHeight: '38',
    // floatingWidth: '0',

    // quantity button styles
    quantityButtonStyle: productButtonStyle,
    quantityButtonColor: theme.productButtonColor,
    quantityButtonBorderRadius: theme.productButtonBorderRadius,
    quantityButtonTextColor: productButtonTextColor,
    quantityButtonFontSize: theme.productButtonFontSize,
    quantityButtonMobileFontSize: theme.productButtonMobileFontSize,
    quantityButtonFontStyle: theme.productButtonFontStyle,
    quantityButtonFontWeight: theme.productButtonFontWeight,
    quantityButtonTextDecoration: theme.productButtonTextDecoration,
    quantityButtonTextAlignment: theme.productButtonTextAlignment,
    quantityButtonFontFamily: theme.productButtonFontFamily,
    quantityButtonPadding: theme.productButtonPadding,
    quantityButtonMargin: theme.productButtonMargin,
    quantityButtonHeight: theme.productButtonHeight,
    quantityButtonMobileHeight: theme.productButtonMobileHeight,
    quantityButtonWidthStyle: theme.productButtonWidthStyle,
    quantityButtonWidth: theme.productButtonWidth,
    quantityButtonMobileWidth: theme.productButtonMobileWidth,

    vdOptionTextMargin: '0px 0px 0px 0px',

    vdOptionDiscountTextColor: '#202223',
    vdOptionDiscountFontWeight: 'normal',
    vdOptionDiscountFontStyle: 'normal',
    vdOptionDiscountTextAlignment: 'center',
    vdOptionDiscountMargin: '0px 0px 0px 0px',
    vdOptionDiscountBorderRadius: '50px',

    vdPriceFontWeight: 'bold',
    vdPriceFontStyle: 'normal',
    vdPriceTextAlignment: 'center',
    vdPriceMargin: '0px 0px 0px 0px',

    vdOfferPriceFontWeight: 'bold',
    vdOfferPriceFontStyle: 'normal',
    vdOfferPriceTextAlignment: 'center',
    vdOfferPriceTextMargin: '0px 0px 0px 0px',

    vdPerItemTextColor: '#323232',
    vdPerItemFontWeight: '400',
    vdPerItemFontStyle: 'normal',
    vdPerItemTextAlignment: 'center',
    vdPerItemMargin: '0px 0px 0px 0px',

    vdOptionBannerBorderRadius: '50px',

    isCarouselArrowsAlwaysVisible: false,
  };

  if (
    ['raevoluz.myshopify.com', 'raevoluz-developers.myshopify.com'].includes(
      shopURL,
    )
  ) {
    newValues.isSelectedVariantItemsDisabled = true;
  }

  if (shopURL === 'elizabeth-scarlett.myshopify.com') {
    newValues.offerHeaderMobileFont = 'Frank Ruhl Libre';
    newValues.productNameFontFamily = 'Frank Ruhl Libre';
  }

  if (['stuffcooltest.myshopify.com'].includes(shopURL)) {
    newValues.offerHeaderFontFamily = 'Poppins';
    newValues.bottomBarButtonFontFamily = 'Poppins';
  }

  if (['manchester-museum.myshopify.com'].includes(shopURL)) {
    newValues.isPopupCloseButtonEnabled = false;
  }

  if (
    [
      'admin-b60a.myshopify.com',
      'spreadhome.myshopify.com',
      'party-love-australia.myshopify.com',
      'maplin-uk.myshopify.com',
    ].includes(shopURL)
  ) {
    newValues.isProductImageClickGoToPage = true;
  }

  if (['cosmedix-shop.myshopify.com'].includes(shopURL)) {
    newValues.isPopupBackdropClickEnabled = true;
  }

  if (['cosmedix-shop.myshopify.com'].includes(shopURL)) {
    newValues.isPopupBackdropClickEnabled = true;
  }

  // styles added on restructuring
  if (!isEmbedded) {
    if (['longevitybox.myshopify.com'].includes(shopURL)) {
      newValues.quantityButtonStyle = 'line';
      newValues.quantityButtonColor = '#000000';
      newValues.quantityButtonTextColor = '#000000';
    }

    if (['wheelhousecycleclub.myshopify.com'].includes(shopURL)) {
      newValues.floatingBorderRadius = '0';
    }

    if (['bluetyga.myshopify.com'].includes(shopURL)) {
      newValues.floatingBottomPosition = '16%';
    }
  }

  if (
    offerType === 'embedded-crossell' ||
    // offerType === 'crossell' || // added for admin
    offerType === 'embedded-freegift' // ||
    // offerType === 'freegift' // added for admin
  ) {
    // Custom widgetMargin start
    if (shopURL === 'hardpressed-print-studo.myshopify.com') {
      newValues.widgetMargin = '15px 0px 10px 0px';
      newValues.widgetMobileMargin = '15px 0px 10px 0px';
    }

    if (shopURL === 'fjorden-camera-grip.myshopify.com') {
      newValues.widgetMargin = '40px 0px 0px 0px';
      newValues.widgetMobileMargin = '40px 0px 0px 0px';
    }

    if (shopURL === 'quirky-perks-new.myshopify.com') {
      newValues.widgetMargin = '5px 0px 0px 0px';
      newValues.widgetMobileMargin = '5px 0px 0px 0px';
    }

    if (shopURL === 'sandstorm-kenya.myshopify.com') {
      newValues.widgetMargin = '20px 0px 0px 0px';
      newValues.widgetMobileMargin = '20px 0px 0px 0px';
    }

    if (shopURL === 'lessence-des-notes.myshopify.com') {
      newValues.widgetMargin = '10px 0px 0px 0px';
      newValues.widgetMobileMargin = '10px 0px 0px 0px';
    }

    // widgetMobileMargin
    if (shopURL === 'moonglow-jewelry.myshopify.com') {
      newValues.widgetMobileMargin = '4px 12px 0px 12px';
    }
    // Custom widgetMargin end

    // Custom widgetPadding start
    if (shopURL === 'yoga-studio-store.myshopify.com') {
      newValues.widgetPadding = '0px 0px 0px 10px';
      newValues.widgetMobilePadding = '0px 0px 0px 10px';
    }

    if (shopURL === 'btstores-1571.myshopify.com') {
      newValues.widgetPadding = '134px 75px 50px 75px';
      newValues.widgetMobilePadding = '80px 30px 60px 30px';
      newValues.offerHeaderTextAlignment = 'left';
    }

    if (shopURL === 'ericajewelstoronro.myshopify.com') {
      newValues.widgetPadding = '120px 0px 0px 0px';
      newValues.widgetMobilePadding = '90px 0px 0px 0px';
    }
    // Custom widgetPadding end

    if (isKnackShop(shopURL) || shopURL === '1moreusa.myshopify.com') {
      newValues.offerHeaderTextAlignment = 'left';
    }

    if (isKnackShop(shopURL)) {
      newValues.widgetBorderRadius = '0px 0px 10px 10px';
      newValues.offerHeaderPadding = '20px 13px 20px 13px';
      newValues.offerHeaderMobilePadding = '20px 13px 20px 13px';
      newValues.offerHeaderFontFamily = 'publica_slabbold';
      newValues.productImageCursor = '';
    }

    if (shopURL === 'shopboomandmellow.myshopify.com') {
      newValues.offerHeaderPadding = '0px 0px 20px 0px';
      newValues.offerHeaderMobilePadding = '0px 0px 20px 0px';
    }

    if (shopURL === 'ericajewelstoronro.myshopify.com') {
      newValues.offerHeaderPadding = '0px 0px 50px 0px';
      newValues.offerHeaderMobilePadding = '0px 0px 30px 0px';
    }

    if (shopURL === 'elizabeth-scarlett.myshopify.com') {
      newValues.offerHeaderFontFamily = 'Frank Ruhl Libre';
    }

    if (shopURL === 'softedgestudio.myshopify.com') {
      newValues.offerHeaderFontFamily = 'Suisse';
    }

    if (shopURL === 'monk-commerce.myshopify.com') {
      newValues.productItemBodyPadding = '0px 0px 0px 18px';
    }
  }

  // CVB styles
  if (offerType === 'cvb') {
    if (shopURL === 'onelove-shop-590a.myshopify.com') {
      newValues.cvbBarContainerMargin = '0px 0px 45px 0px';
    }

    if (isKnackShop(shopURL)) {
      newValues.cvbOfferHeaderBarPadding = '25px 4px 25px 4px';
      newValues.cvbBarContainerMargin = '0px 13px 16px 13px';
      newValues.widgetBorderRadius = '10px 10px 0px 0px';
    }
  }

  if (
    offerType === 'embedded-fbt' // ||
    // offerType === 'fbt' // added for admin
  ) {
    if (shopURL === 'happispace.myshopify.com') {
      newValues.widgetMargin = '20px 0px 0px 0px';
      newValues.widgetMobileMargin = '20px 0px 0px 0px';
    }

    if (shopURL === 'christine-koth.myshopify.com') {
      newValues.fbtLargeWidthConAlignment = 'center';
      newValues.fbtLargeWidthImagesAlignment = 'center';
    }
  }

  if (['shopyona.myshopify.com'].includes(shopURL)) {
    newValues.isProductTitleClickGoToPage = true;
  }

  if (['foliagedreams.myshopify.com'].includes(shopURL)) {
    newValues.isToggleCheckboxOnImageClick = true;
  }

  if (['deichbrise-onlineshop.myshopify.com'].includes(shopURL)) {
    newValues.isCarouselArrowsAlwaysVisible = true;
  }

  if (['a88723-60.myshopify.com'].includes(shopURL)) {
    newValues.discountCodeChipBackgroundColor = '#FFF7F2';
  }

  // styles added on restructuring

  return { ...theme, ...newValues };
};

export const getIsProductAddonsSelected = ({
  offerType,
  mobileLayoutType,
  desktopLayoutType,
  isMobile,
  productAddonLayouts,
}) => {
  const eligibleOfferTypes = ['crossell', 'freegift'];
  return (
    eligibleOfferTypes.includes(offerType) &&
    ((productAddonLayouts.includes(mobileLayoutType) && isMobile) ||
      (productAddonLayouts.includes(desktopLayoutType) && !isMobile))
  );
};

const isKnackShop = shopURL =>
  [
    'knack-roularta.myshopify.com',
    'libelle-lekker-roularta.myshopify.com',
    'test-sub-rmg.myshopify.com',
  ].includes(shopURL);
